import { render, staticRenderFns } from "./RequisicoesDash.vue?vue&type=template&id=fb2c3dd8"
import script from "./RequisicoesDash.vue?vue&type=script&lang=js"
export * from "./RequisicoesDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports